var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-0 d-flex align-start",
              class: { "mt-md-n10": !_vm.noMarginTop },
              attrs: { cols: "12", sm: "12", md: _vm.showFilters ? 4 : 2 },
            },
            [
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showFilters,
                      expression: "showFilters",
                    },
                  ],
                  staticClass: "pb-2",
                  attrs: { elevation: "0", outlined: "" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "mx-0 pt-2" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pa-0 header-font py-2",
                              staticStyle: { "font-size": "22px" },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.filters")))]
                          ),
                          _vm._v(" "),
                          _vm.currentUser.clientType === "Media" ||
                          _vm.currentUser.clientType === "Driblab"
                            ? _c("MediaModeForm", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showFilters,
                                    expression: "showFilters",
                                  },
                                ],
                                attrs: {
                                  fields: _vm.mediaModeFields,
                                  mediaMode: _vm.mediaMode,
                                  mediaModeData: _vm.mediaModeData,
                                  selectorMode: "",
                                },
                                on: {
                                  mediaModeChange: function ($event) {
                                    return _vm.onMediaModeChange($event)
                                  },
                                  mediaModeDataChange: function ($event) {
                                    return _vm.onMediaModeDataChange($event)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-1",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                            },
                            [_vm._v(_vm._s(_vm.$t("general.orientation")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-radio-group",
                            {
                              staticClass: "mt-0",
                              attrs: { dense: "", "hide-details": "", row: "" },
                              on: {
                                change: function ($event) {
                                  _vm.xtMap++
                                },
                              },
                              model: {
                                value: _vm.orientationModel,
                                callback: function ($$v) {
                                  _vm.orientationModel = $$v
                                },
                                expression: "orientationModel",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: {
                                  color: _vm.darkMode
                                    ? "secondary darken-2"
                                    : "secondary",
                                  value: "horizontal",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "body-1 primary--text",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("general.horizontal")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: {
                                  color: _vm.darkMode
                                    ? "secondary darken-2"
                                    : "secondary",
                                  value: "vertical",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "body-1 primary--text",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("general.vertical"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-1",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "my-0 pa-0 primary--text font-weight-bold body-1",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("game.gameThreat.typeOfPlay"))
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex flex-wrap pt-0 pb-1",
                          attrs: { cols: "12" },
                        },
                        _vm._l(_vm.typeOfPlay, function (typesPlay, index) {
                          return _c("v-checkbox", {
                            key: typesPlay,
                            staticClass: "px-1 py-0 ma-0",
                            attrs: {
                              label: typesPlay,
                              color: "secondary",
                              value: typesPlay,
                              "hide-details": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateShots()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "body-1 primary--text" },
                                        [_vm._v(_vm._s(typesPlay))]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.typeOfPlayModel,
                              callback: function ($$v) {
                                _vm.typeOfPlayModel = $$v
                              },
                              expression: "typeOfPlayModel",
                            },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-1",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("game.gameThreat.actionEnding"))
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex flex-wrap pt-0 pb-1",
                          attrs: { cols: "12" },
                        },
                        _vm._l(
                          _vm.actionEndings,
                          function (actionEnding, index) {
                            return _c("v-checkbox", {
                              key: actionEnding,
                              staticClass: "px-1 py-0 ma-0",
                              attrs: {
                                label: _vm.$t(
                                  `game.gameThreat.${actionEnding}`
                                ),
                                color: "secondary",
                                value: actionEnding,
                                "hide-details": "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateShots()
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "body-1 primary--text",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  `game.gameThreat.${actionEnding}`
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.actionEndingsModel,
                                callback: function ($$v) {
                                  _vm.actionEndingsModel = $$v
                                },
                                expression: "actionEndingsModel",
                              },
                            })
                          }
                        ),
                        1
                      ),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-1",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                                },
                                [_vm._v(_vm._s(_vm.$t("general.period")))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-wrap py-0",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "px-1 py-0 ma-0",
                                attrs: {
                                  label: _vm.$t("general.firstHalf"),
                                  color: "secondary",
                                  value: "period1",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-1 primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("general.firstHalf")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3581771750
                                ),
                                model: {
                                  value: _vm.periods,
                                  callback: function ($$v) {
                                    _vm.periods = $$v
                                  },
                                  expression: "periods",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                staticClass: "px-1 py-0 ma-0",
                                attrs: {
                                  label: _vm.$t("general.secondHalf"),
                                  color: "secondary",
                                  value: "period2",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-1 primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("general.secondHalf")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1931206316
                                ),
                                model: {
                                  value: _vm.periods,
                                  callback: function ($$v) {
                                    _vm.periods = $$v
                                  },
                                  expression: "periods",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions && _vm.hasFirstOT
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-0",
                              attrs: { cols: "12", md: "6" },
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "ma-0 py-0",
                                attrs: {
                                  label: _vm.$t("general.firstPeriodOT"),
                                  color: "secondary",
                                  value: "period3",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-1 primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "general.firstPeriodOT"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2642105819
                                ),
                                model: {
                                  value: _vm.periods,
                                  callback: function ($$v) {
                                    _vm.periods = $$v
                                  },
                                  expression: "periods",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions && _vm.hasSecondOT
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-0",
                              attrs: { cols: "12", md: "6" },
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "ma-0 py-0",
                                attrs: {
                                  label: _vm.$t("general.secondPeriodOT"),
                                  color: "secondary",
                                  value: "period4",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-1 primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "general.secondPeriodOT"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1873983217
                                ),
                                model: {
                                  value: _vm.periods,
                                  callback: function ($$v) {
                                    _vm.periods = $$v
                                  },
                                  expression: "periods",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex pt-1 pb-2 my-2",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c("v-range-slider", {
                                staticClass: "align-center py-0",
                                attrs: {
                                  "thumb-label": "",
                                  max: _vm.minutesMax,
                                  min: _vm.minutesMin,
                                  step: "1",
                                  "hide-details": "",
                                  color: `secondary ${
                                    _vm.$vuetify.theme.dark ? "lighten-3" : ""
                                  }`,
                                },
                                on: { input: _vm.updateShots },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "primary--text font-weight-bold body-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.minutes"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 subheader-font monospace-font",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      `(${_vm.minutesMin} - ${_vm.minutesMax})`
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2174348164
                                ),
                                model: {
                                  value: _vm.minutes,
                                  callback: function ($$v) {
                                    _vm.minutes = $$v
                                  },
                                  expression: "minutes",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex pt-1 pb-2 mb-5",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c("v-range-slider", {
                            staticClass: "align-center py-0",
                            attrs: {
                              label: _vm.$t("game.gameThreat.threat"),
                              "thumb-label": "",
                              max: _vm.threatMax,
                              min: _vm.threatMin,
                              step: "0.01",
                              "hide-details": "",
                              color: `secondary ${
                                _vm.$vuetify.theme.dark ? "lighten-3" : ""
                              }`,
                            },
                            on: { input: _vm.updateShots },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text font-weight-bold body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("game.gameThreat.threat")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 subheader-font monospace-font",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                `(${_vm.threatMin} - ${_vm.threatMax})`
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.threat,
                              callback: function ($$v) {
                                _vm.threat = $$v
                              },
                              expression: "threat",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end pt-3 pb-1 px-2",
                          attrs: { cols: "12" },
                        },
                        [_c("v-divider", { staticClass: "w-100" })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end pt-2 pb-1 px-2",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsPNG()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("\n                file_download")]
                              ),
                              _vm._v(" "),
                              _c("span", {}, [_vm._v("PNG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsSVG()
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("file_download"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("SVG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                                loading: _vm.loadingExport,
                                disabled: !_vm.chartSize,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onGenerateIFrameClick()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("share")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Embed")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-shrink-0 ml-2 align-self-start" },
                [_vm._t("filters-toggle")],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              ref: "chart",
              staticClass: "pt-0 d-flex justify-center'",
              attrs: {
                cols: "12",
                sm: "12",
                md: _vm.showFilters ? 8 : 10,
                id: "chart",
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-column align-center w-100" },
                [
                  _vm.avatarSize && _vm.mediaMode && _vm.game
                    ? _c("GameAvatarMedia", {
                        key: `avatar-${_vm.orientationModel}`,
                        ref: "gameAvatarMediaRef",
                        attrs: {
                          width: _vm.avatarSize.width,
                          height: _vm.avatarSize.height,
                          id: `${_vm.gameId}-${_vm.chartId}`,
                          game: _vm.game,
                          margin: _vm.margin,
                          titleLeft: _vm.isMobile
                            ? _vm.game.homeTeamAlias
                            : _vm.game.homeTeamName,
                          titleRight: _vm.isMobile
                            ? _vm.game.awayTeamAlias
                            : _vm.game.awayTeamName,
                          leftColor: _vm.isWhite(
                            _vm.mediaModeData.leftFillColor
                          )
                            ? _vm.mediaModeData.leftBorderColor
                            : _vm.mediaModeData.leftFillColor,
                          rightColor: _vm.isWhite(
                            _vm.mediaModeData.rightFillColor
                          )
                            ? _vm.mediaModeData.rightBorderColor
                            : _vm.mediaModeData.rightFillColor,
                          bgColor: _vm.mediaModeData.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          type: "gameThreat",
                          lineDistance: _vm.mediaModeData.lineLength,
                          avatarSize: _vm.mediaModeData.avatarSize,
                          lineWeight: _vm.mediaModeData.lineWeight,
                          titleFontSize: _vm.mediaModeData.titleFontSize,
                          titleFontWeight: _vm.mediaModeData.titleFontWeight,
                          subtitle: _vm.mediaModeData.subtitle,
                          subtitleFontSize: _vm.mediaModeData.subtitleFontSize,
                          subtitleFontWeight:
                            _vm.mediaModeData.subtitleFontWeight,
                          subtitle2: _vm.mediaModeData.subtitle2,
                          subtitle2FontSize:
                            _vm.mediaModeData.subtitle2FontSize,
                          subtitle2FontWeight:
                            _vm.mediaModeData.subtitle2FontWeight,
                          isVertical: _vm.orientationModel === "vertical",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.size != 0 &&
                  _vm.game !== null &&
                  _vm.filteredShots != null &&
                  _vm.filteredShots.length > 0
                    ? _c("XTChart", {
                        key: _vm.xtMap,
                        attrs: {
                          size: _vm.size,
                          type: _vm.type,
                          game: _vm.game,
                          plays: _vm.filteredShots,
                          minXT: _vm.threat[0],
                          maxXT: _vm.threat[1],
                          language: _vm.currentUserLanguage,
                          typeOfPlay: _vm.typeOfPlayModel,
                          homeFillColor: _vm.mediaModeData.leftFillColor,
                          awayFillColor: _vm.mediaModeData.rightFillColor,
                          homeBorderColor: _vm.mediaModeData.leftBorderColor,
                          awayBorderColor: _vm.mediaModeData.rightBorderColor,
                          homeTeamName: _vm.mediaModeData.titleLeft,
                          awayTeamName: _vm.mediaModeData.titleRight,
                          mediaMode: _vm.mediaMode,
                          id: `${_vm.gameId}-${_vm.chartId}`,
                          filterShotTypeText: _vm.gameFilterTypeOfPlayText,
                          filterTimeText: _vm.gameFilterTimeText,
                          filterActionEndingText:
                            _vm.gameFilterActionEndingText,
                          orientation: _vm.orientationModel,
                        },
                        on: {
                          sizeChange: function ($event) {
                            return _vm.onChartSizeChange($event)
                          },
                          loaded: function ($event) {
                            return _vm.onLoaded($event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.game &&
                  _vm.avatarSize &&
                  _vm.size &&
                  _vm.mediaMode &&
                  _vm.mediaModeData.socialMedia
                    ? _c("DriblabSocialMedia", {
                        ref: "driblabSocialMediaRef",
                        attrs: {
                          width: _vm.avatarSize.width,
                          height: 50,
                          id: `${_vm.gameId}-${_vm.chartId}`,
                          margin: _vm.margin,
                          bgColor: _vm.mediaModeData.bgColor,
                          textColor: _vm.mediaModeData.textColor,
                          fontSize: _vm.mediaModeData.socialMediaFontSize,
                          fontWeight: _vm.mediaModeData.socialMediaFontWeight,
                          logoCfg: _vm.mediaModeData.logo,
                          sponsor: _vm.mediaModeData.sponsor.dataUrl,
                          type: "gameThreat",
                          isVertical: _vm.orientationModel === "vertical",
                          isGame: true,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.game
        ? _c("ChartExportLinksModal", {
            ref: "chartExportLinksModalRef",
            attrs: {
              title: `${_vm.game.homeTeamName} ${_vm.game.homeTeamScore} - ${_vm.game.awayTeamScore} ${_vm.game.awayTeamName}`,
              subtitle: _vm.$t("playerDetail.threatMap"),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }